import { render, staticRenderFns } from "./validate.vue?vue&type=template&id=273af290&scoped=true&"
import script from "./validate.vue?vue&type=script&lang=js&"
export * from "./validate.vue?vue&type=script&lang=js&"
import style0 from "./validate.vue?vue&type=style&index=0&id=273af290&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273af290",
  null
  
)

/* custom blocks */
import block0 from "./validate.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

component.options.__file = "validate.vue"
export default component.exports